const PRESENTATION_STARTED = 'PRESENTATION_STARTED';
const PRESENTATION_ENDED = 'PRESENTATION_ENDED';
const PRESENTATION_UPDATED = 'PRESENTATION_UPDATED';

export {
  PRESENTATION_STARTED,
  PRESENTATION_ENDED,
  PRESENTATION_UPDATED,
};
